import {useMutation, useQuery} from '@tanstack/react-query'

import {downloadInventoryCsv, listEquipmentExceptions, listWaitingForUnitNumbers} from './api'
import {equipmentCheckKeys} from './query-keys'

const FIVE_MINUTES = 5 * 60 * 1000

export function useEquipmentExceptions(yardId: string | null, options?: {enabled?: boolean}) {
    return useQuery({
        queryKey: equipmentCheckKeys.exceptions(yardId),
        queryFn: () => listEquipmentExceptions(yardId),
        staleTime: FIVE_MINUTES,
        enabled: options?.enabled ?? true,
    })
}

export function useWaitingForUnitNumbers(yardId: string | null) {
    return useQuery({
        queryKey: equipmentCheckKeys.waitingForUnitNumbers(yardId),
        queryFn: () => listWaitingForUnitNumbers(yardId),
    })
}

export function useDownloadInventoryCsv() {
    return useMutation({
        mutationFn: (yardId: string | null) => downloadInventoryCsv(yardId),
    })
}
